module.exports = __webpack_public_path__ + "static/media/Brenda.9eacb0ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Brenda.jpg
// module id = 350
// module chunks = 0